class EventManager {
  private static instance: EventManager;

  private eventTarget: EventTarget;

  private constructor() {
    this.eventTarget = new EventTarget();
  }

  public static getInstance(): EventManager {
    if (!EventManager.instance) {
      EventManager.instance = new EventManager();
    }
    return EventManager.instance;
  }

  public dispatchUpdateEvent(eventType: string, data?: any): void {
    const event = new CustomEvent(eventType, { detail: data });
    this.eventTarget.dispatchEvent(event);
  }

  public addEventListener(eventType: string, callback: (event: CustomEvent) => void): void {
    this.eventTarget.addEventListener(eventType, callback as EventListener);
  }

  public removeEventListener(eventType: string, callback: (event: CustomEvent) => void): void {
    this.eventTarget.removeEventListener(eventType, callback as EventListener);
  }
}

export const eventManager = EventManager.getInstance();

export const UPDATE_EVENTS = {
  VENDEDOR_UPDATED: 'vendedor-updated',
  ORCAMENTO_UPDATED: 'orcamento-updated',
  CLIENTE_UPDATED: 'cliente-updated',
  PRODUTO_UPDATED: 'produto-updated',
} as const;
